import { useEffect } from 'preact/hooks'
import { initTrinioCheckout } from 'site/sdk/trinio/mod.ts'

export default function TrinioCheckoutProvider() {
    useEffect(() => {
        const initialize = () => {
            initTrinioCheckout()
        }

        if ('requestIdleCallback' in globalThis) {
            const id = globalThis.requestIdleCallback(initialize, { timeout: 3_000 })
            return () => globalThis.cancelIdleCallback(id)
        }

        const id = setTimeout(initialize, 1_500)
        return () => clearTimeout(id)
    }, [])

    return null
}
